import React, { useState } from "react";
import { Formik, Form, useField, ErrorMessage } from "formik";
import * as Yup from "yup";
import styles from './billing.module.css';
import { useParams } from "react-router-dom";
import Asterisk from "../../../../components/asterisk/Asterisk";
import { TextField } from "../../controllers/quotationControllers";
import { Submit } from "../../../../components/button/buttons";
import { ACTION_STATUS, DEMAND_ACTIONS } from "../../../../utils/constants/DemandConstant";
import { connect } from "react-redux";
import { addDemandAction } from "../../../../redux/actions/demand/demand.action";
import { openAlertPopup } from "../../../../redux/actions/Alert/alert.action";
import IMAGES from "../../../../assets/images/images";
import DatePickerField from "../../../../components/datePicker/DatePickerField";
import { FormErrorLabel } from "../../../../components/label/Labels";

const emptyMethod = () => {};

const Billing = ({handelServiceDetailapi,billingData={},actionStatus,isEditServiceDate=false, onToggleScreen = emptyMethod, ...props}) => {
  let { requestId } = useParams();
  const schema = Yup.object({
    isOnBoarded: Yup.boolean().required().oneOf([true], "Please select checkbox"),
    serviceStartDate: Yup.string().required("Service Start Date is a required")
  });
  const canEdit = actionStatus == ACTION_STATUS.BILLING_ONBOARDING_COMPLETED && isEditServiceDate && billingData?.canEditServiceActivationDate==true && billingData?.canConfirmServiceActivationDate==false ? true : false  
  
  let _initialValues={}
    if (canEdit){
      _initialValues={
        isOnBoarded:true,
        serviceStartDate:billingData?.serviceStartDate || null
      }
    }else{
      _initialValues= {
        isOnBoarded: false,
        serviceStartDate: null
      }
    }

  return (
    //  has(demandDetail?.allowedActions, DEMAND_ACTIONS.SUBMIT_SIGNED_ORDERFORM)&&
    //className={styles.container}
      <div className={styles.container}>  
        <Formik
          initialValues={_initialValues}
          validationSchema={schema}
          onSubmit={async (values,{setSubmitting}) => {
            setSubmitting(true);
            try {
              let payload = {}

              if(canEdit){
                payload = {
                  action:DEMAND_ACTIONS.EDIT_SERVICE_START_DATE,
                  stateData: {...values,canEditServiceActivationDate:true,canConfirmServiceActivationDate:false}  // canEditServiceActivationDate default true
                }
              }else{
                payload = {
                  action:DEMAND_ACTIONS.COMPLETE_BILLING,
                  stateData: {...values,canEditServiceActivationDate:true,canConfirmServiceActivationDate:false}  // canEditServiceActivationDate default true
                }
              }
              const res = await props?.addDemandAction(payload, requestId);
              if (!res) {
                  props.openAlertPopup({
                      message: "Unable to process. Please try again.",
                      image: IMAGES.error,
                  });
                  return;
              }
              onToggleScreen?.()
              await handelServiceDetailapi();
              props.openAlertPopup({
                  message: "The service start date has been successfully communicated to the customer.",
                  image: IMAGES.success,
              });
            } catch (error){
              props?.openAlertPopup({
                message:"An error occurred while processing your request. Please try again later.",
                image: IMAGES.error,
              });
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {({ values, setFieldValue, handleSubmit,isValid, dirty,isSubmitting}) => (
            <Form onSubmit={handleSubmit}>
              <div className={styles.wrapper}>
              {
                !canEdit && (
                  <>
                    <div className={styles.sectionheading}>
                      Use this section to confirm Billing Onboarding (FinCA). From the confirmed date, the service will be activated and billing will commence.
                    </div>
                    <label className={styles.checkboxRow}>
                      <input
                        type="checkbox"
                        name="isOnBoarded"
                        checked={values.isOnBoarded}
                        onChange={(e) =>
                          setFieldValue("isOnBoarded", e.target.checked)
                        }
                      />
                      <span className={styles.checjboxlabel}>Please confirm if billing onboarding has been completed?</span>
                    </label>
                    <br/>
                    <ErrorMessage name ="isOnBoarded">
                        {(msg)=><FormErrorLabel text={msg} />}
                    </ErrorMessage>
                  </>
                )
              }
                <div className={styles.field}>
                    {/* <TextField
                      name="serviceStartDate"
                      type="text"
                      label="Service Start Date"
                      isMandatory
                    /> */}
                    <DatePickerField
                      name="serviceStartDate"
                      type="date"
                      label="Service Start Date"
                      dateFormat="dd/MM/yyyy"                
                      minDate={(() => {
                        const d = new Date();
                        d.setHours(0, 0, 0, 0);
                        d.setDate(d.getDate() + 6);
                        return d;
                        })()}
                      // maxDate={null}
                      placeholderText="dd/mm/yyyy"
                      labelstyle={styles.labelstyle}
                  />
                  <div className={styles.footerwrapper}>
                      <div className={styles.footerupload}>
                        <Submit type={"submit"} disabled={!dirty} className={styles.acknowledgment} title={"Submit"} isSubmitting={isSubmitting}/>
                       {
                        canEdit && (<button
                          type="button"
                          onClick={() => {
                            onToggleScreen?.()
                          }}
                          disabled = {isSubmitting}
                          className={styles.cancelBtn}
                        >
                          Cancel
                        </button>)
                       } 
                      </div>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
  );
};

const mapStateToProps = (state) => {
  return null;
};

const mapDispatchToProps = (dispatch) => {
  return {
    addDemandAction: (payload,id)=>{
      return dispatch(addDemandAction(payload,id))
    },
    openAlertPopup: (alertHeader,alertmessage) => {
      return dispatch(openAlertPopup(alertHeader,alertmessage))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Billing);